<template>
  <div class="bed-settings">
    <div class="header">
      <h2>🏥 Bed Settings</h2>

      <div class="header-actions">
        <button class="btn-add" @click="showaddBed">+ Add Bed</button>.
        <router-link to="ward_setting" class="ward-link"
          >Go to Ward Settings →</router-link
        >
        <router-link to="bed_classes" class="ward-link-purple"
          >Go to Bed Class →</router-link
        >
      </div>
    </div>

    <div class="filter-bar">
      <label>Filter by Ward:</label>
      <select v-model="selectedWard">
        <option value="">All</option>
        <option v-for="ward in wards" :key="ward.id" :value="ward.id">
          {{ ward.ward_name }}
        </option>
      </select>
    </div>

    <table class="bed-table">
      <thead>
        <tr>
          <th>#</th>
          <th>Bed Number</th>
          <th>Ward</th>
          <th>Charge Class</th>
          <th>Type</th>
          <th>Occupied</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(bed, index) in filteredBeds" :key="bed.id">
          <td>{{ index + 1 }}</td>
          <td>{{ bed.bed_number }}</td>
          <td>{{ bed.ward_name }}</td>
          <td>{{ bed.charge_class_name }}</td>
          <td>{{ bed.bed_type }}</td>
          <td>
            <span :class="bed.is_occupied ? 'occupied' : 'vacant'">
              {{ bed.is_occupied ? "Yes" : "No" }}
            </span>
          </td>
          <td>
            <button class="btn-edit" @click="editBed(bed)">Edit</button>
            <button class="btn-delete" @click="deleteBed(bed.id)">
              Delete
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <BedAddModal v-if="showBedModal" :bedToEdit="selectedBed" @close="closeBed" />
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import BedAddModal from "./add_bed_modal.vue";
export default {
  name: "BedSettings",
  data() {
    return {
      selectedWard: "",
      showBedModal: false,
      wards: [],
      beds: [],
    };
  },
  components: {
    BedAddModal,
  },
  computed: {
    filteredBeds() {
      if (this.selectedWard) {
        return this.beds.filter(
          (bed) => bed.ward_id === Number(this.selectedWard)
        );
      }
      return this.beds;
    },
  },
  methods: {
    closeBed() {
      this.showBedModal = false;
      this.fetchData();
    },
    async get_wards() {
      const url = "inpatient/getCompanyWards";
      const data = await generalApiRequest(url, "GET", {}, 1);
      console.log(data);

      this.wards = data;
    },
    async fetchData() {
      const class_url = "getCompanyBeds/all";
      const class_body = {};
      const resp = await generalApiRequest(class_url, "GET", class_body, 1);
      //   console.log(resp);
      this.beds = resp.data;
    },
    showaddBed() {
      this.showBedModal = true;
    },
    getWardName(id) {
      const ward = this.wards.find((w) => w.id === id);
      return ward ? ward.ward_name : "Unknown";
    },
    editBed(bed) {
      alert(`Editing bed: ${bed.bed_number}`);
    },
    deleteBed(id) {
      if (confirm("Are you sure you want to delete this bed?")) {
        this.beds = this.beds.filter((bed) => bed.id !== id);
      }
    },
  },
  mounted() {
    this.get_wards();
    this.fetchData();
  },
};
</script>

<style scoped>
.bed-settings {
  padding: 1.5rem;
  font-family: Arial, sans-serif;
  color: #333;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.header h2 {
  font-size: 1.5rem;
}

.ward-link {
  background: #2786f7;
  color: #fff;
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 0.3rem;
  font-size: 0.9rem;
}
.ward-link-purple {
  background: #d016a8;
  color: #fff;
  padding: 0.5rem 1rem;
  text-decoration: none;
  border-radius: 0.3rem;
  font-size: 0.9rem;
}

.filter-bar {
  margin-bottom: 1rem;
  display: flex;
  gap: 0.6rem;
  align-items: center;
}

.filter-bar label {
  font-weight: 600;
}

.filter-bar select {
  padding: 0.4rem 0.6rem;
  border-radius: 0.3rem;
  border: 1px solid #ccc;
}

.bed-table {
  width: 100%;
  border-collapse: collapse;
}

.bed-table th,
.bed-table td {
  border: 1px solid #ddd;
  padding: 0.6rem;
  text-align: center;
  font-size: 0.95rem;
}

.bed-table th {
  background: #f5f5f5;
  font-weight: 600;
}

.bed-table tr:nth-child(even) {
  background: #fafafa;
}

.occupied {
  color: #e31919;
  font-weight: 600;
}

.vacant {
  color: #1e7c1e;
  font-weight: 600;
}

.btn-edit,
.btn-delete {
  padding: 0.35rem 0.7rem;
  border: none;
  border-radius: 0.25rem;
  cursor: pointer;
  font-size: 0.85rem;
}

.btn-edit {
  background: #2786f7;
  color: #fff;
  margin-right: 0.4rem;
}

.btn-delete {
  background: #e31919;
  color: #fff;
}
</style>
